import { ConfigurationCompletedThankYouPage as Admin } from './AdminConfigurationCompletedThankYouPage';
import { ConfigurationCompletedThankYouPage as Learning } from './LearningConfigurationCompletedThankYouPage';

export const ConfigurationCompletedThankYouPage = {
  Admin,
  Learning,
};
